/**
 * Card 컴포넌트
 * @description 내용을 담는 껍데기. 폭은 부모를 채우고 높이는 내용에 맞춘다. 상호작용을
 *   스스로 처리하지 않고 `state` 를 받기만 한다. 앱 DS `Card` 의 웹 포팅.
 * @example
 * <Card slot={<PostBody post={post} />} />
 * <Card tone='secondary' padding='md' slot={content} />
 */
import { memo } from "react";

import { cardStyles } from "./Card.styles";
import type { CardProps } from "./Card.types";

const Card = memo<CardProps>(
  ({ tone, state, radius, padding, slot, className, testID }) => (
    <div
      className={cardStyles({ tone, state, radius, padding, className })}
      data-testid={testID}
    >
      {slot}
    </div>
  ),
);

Card.displayName = "Card";

export default Card;
